import { AppThunk } from '../../../index';
import { signUpFailed, signUpStarted, signUpSuccess, logInSuccess } from '../reducer';
import { getUserDetails } from './getUserDetails';

export interface RegisterData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  termsAndPrivacyPolicy: boolean;
  lang: string;
  timezone: string;
  ip: string | null;
  phoneNumber: string | null;
  nip: string | null;
  turnstileToken: string;
}

export const signUpUser =
  (
    {
      email,
      password,
      lastName,
      firstName,
      termsAndPrivacyPolicy,
      lang,
      timezone,
      ip,
      phoneNumber,
      nip,
      turnstileToken,
    }: RegisterData,
    callback?: () => void,
    onFail?: () => void
  ): AppThunk =>
  async (dispatch, _, { auth, functions, analytics }) => {
    dispatch(signUpStarted());
    try {
      const result = await functions.httpsCallable('users-registerUser')({
        email,
        password,
        firstName,
        lastName,
        termsAndPrivacyPolicy,
        lang,
        timezone,
        ip: ip ?? undefined,
        phoneNumber: phoneNumber ?? undefined,
        nip: nip ?? undefined,
        turnstileToken,
      });

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const body = (result.data as any)?.body as {
        uid: string;
        email: string;
        customToken: string | null;
      };

      const signInResult = body.customToken
        ? await auth().signInWithCustomToken(body.customToken)
        : await auth().signInWithEmailAndPassword(body.email, password);

      if (!signInResult.user) {
        throw new Error('Failed to sign in after registration');
      }

      dispatch(signUpSuccess());

      const { uid, email: userEmail } = signInResult.user;

      dispatch(
        logInSuccess({
          uid,
          email: userEmail,
        })
      );
      analytics.identify(uid, { email: userEmail });
      dispatch(getUserDetails(uid));

      if (callback) {
        callback();
      }
    } catch (e) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const error = e as any;
      dispatch(signUpFailed(error.code ?? 'unknown'));

      if (onFail) {
        onFail();
      }
    }
  };
